<template>
  <div>
    <div>
      <!-- <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="Search by title" v-model="title" />
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" @click="searchTitle">
              Search
            </button>
          </div>
        </div> -->

      <div class="form-group">
        <label for="exampleFormControlSelect1"
          ><h5 style="width: 200px">
            <i class="bi bi-person-plus"></i> 분반 보고서
          </h5></label
        >
        <!-- <span
            ><button
              type="button"
              class="btn btn-primary btn-sm"
              @click="AddMember"
            >
              신규
            </button>
          </span> -->
        <!-- @change="onChange(this)" -->
        <select
          class="form-control"
          id="holiday"
          name="holiday"
          v-model="holiday"
          @change="getStudentList(this)"
        >
          <option id="" value="00">날짜를 선택하세요.</option>
          <option
            v-for="daylist in dayLists"
            :key="daylist.dday"
            v-bind:value="daylist.dday"
            :id="daylist.dday"
            :selected="daylist.dday == daylist.cday"
          >
            {{ daylist.dday }}
          </option>
        </select>
      </div>
    </div>

    <div>
      <select
        class="form-control"
        id="gradegroup"
        name="gradegroup"
        v-model="gradegroup"
        @change="getGradeGroup()"
        v-show="this.role == 1 || this.role == 4"
      >
        <option id="" value="00">조회 대상을 선택하세요.</option>
        <option
          v-for="gradelist in gradegrouplist"
          :key="String(gradelist.teacherid) + '-' + String(gradelist.grade != null ? gradelist.grade : '')"
          v-bind:value="gradelist.grade"
          :id="gradelist.grade"
        >
          {{ gradeListLabel(gradelist) }}
        </option>
      </select>
    </div>
    <p></p>

    <div>
      <ul class="list-group" v-if="memberLists.length > 0">
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
          v-for="memberList in memberLists"
          :key="memberList.no"
          style="padding: 0.5rem 0.2rem;"
        >
        <div class="row w-100 m-0">
            <div class="col-6 p-0">
              <div>
                <div class="row m-0 align-items-center">
                  <div class="col-4 p-1">
                    <div
                      v-if="memberList.photo !== null"
                      class="form-group m-0"
                    >
                      <img
                        :src="photourl(memberList.photo)"
                        alt="..."
                        class="img-thumbnail p-0"
                        style="width: 100%; object-fit: cover;"
                      />
                    </div>
                    <div
                      v-else-if="memberList.photo2 !== null"
                      class="form-group m-0"
                    >
                      <img
                        :src="photourl(memberList.photo2)"
                        alt="..."
                        class="img-thumbnail p-0"
                        style="width: 100%; object-fit: cover;"
                      />
                    </div>                    
                    <div
                      v-else
                      class="form-group m-0"
                      style="text-align: left"
                    >
                      <img src="../assets/noimage.png" style="width: 100%" />
                    </div>
                  </div>
                  <div class="col-8 p-1">
                    <div class="d-flex flex-column justify-content-center">
                      <span class="align-middle font-weight-bold" style="font-size: 0.95rem; line-height: 1.2;"
                        >{{ memberList.name }}<span style="font-size: 0.8em; font-weight: normal;">({{ memberList.sex }})</span></span
                      >
                      <span v-if="memberList.points && !['1','2','3','4'].includes(classid)" style="color: blue; font-size: 0.8em; margin-top: 2px; white-space: nowrap;">
                        달란트: {{ memberList.points }}
                      </span>
                      <span v-if="teacherid == '1'" style="margin-top: 2px;">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm py-0 px-1"
                          style="font-size: 0.7rem;"
                          @click="photoreset(memberList, '5')"
                        >
                          Reset
                        </button>
                    </span>
                   </div>                    
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 p-0">
              <div class="d-flex flex-column align-items-end justify-content-center h-100 pr-1">
                <div class="d-flex justify-content-end mb-1">
                  <button
                    type="button"
                    :class="memberList.attendyn == 'Y' ? 'btn btn-primary btn-sm px-2 mr-1' : 'btn btn-secondary btn-sm px-2 mr-1'"
                    @click="attendcheck(memberList, '1')"
                  >
                    부서
                  </button>
                  <button
                    type="button"
                    :class="memberList.cellattendyn == 'Y' ? 'btn btn-warning btn-sm px-2 mr-1' : 'btn btn-secondary btn-sm px-2 mr-1'"
                    @click="attendcheck(memberList, '2')"
                  >
                    분반
                  </button>
                  <button
                    type="button"
                    :class="memberList.pray != null ? 'btn btn-info btn-sm px-2' : 'btn btn-secondary btn-sm px-2'"
                    @click="reporting(memberList)"
                    v-show="role === '1' || role === '3'"
                  >
                    보고서
                  </button>
                </div>
                <div class="d-flex justify-content-end" v-if="!['1','2','3','4'].includes(classid)">
                  <button
                    type="button"
                    class="btn btn-sm px-2"
                    style="background-color: #fff3cd; color: #000; border: 1px solid #ffc107;"
                    @click="openTalentModal(memberList)"
                    v-show="role === '1' || role === '3'"
                  >
                    달란트
                  </button>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>

      <ul class="list-group" v-else>
        <div class="row" style="width: 100%; text-align: center">
          <div class="col-12">조회된 자료가 없습니다.</div>
        </div>
      </ul>
      <!-- <button class="m-3 btn btn-sm btn-danger" @click="removeAllTutorials">
            Remove All
          </button> -->
    </div>

    <div
      class="modal fade"
      id="reportModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="reportModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="reportModalLabel" style="color: blue">
              <span id="plpmo"></span>
              <div>보고서</div>
            </h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <form
                id="addReportForm"
                name="addReportForm"
                v-on:submit="addReportForm"
              >
                <div class="form-group mx-sm-3 mb-2"></div>
                <div class="form-group">
                  <label for="exampleFormControlTextarea1"
                    >{{ form.name }}({{ form.sex }})</label
                  >
                  <textarea
                    class="form-control"
                    id="pl"
                    name="pray"
                    rows="7"
                    v-model="form.pray"
                    required
                    placeholder="기도제목 또는 특이사항을 입력해주세요."
                  ></textarea>
                  <input type="hidden" name="no" v-model="form.no" />
                  <input
                    type="hidden"
                    name="studentid"
                    v-model="form.studentid"
                  />
                  <input
                    type="hidden"
                    name="teacherid"
                    v-model="form.teacherid"
                  />
                  <input type="hidden" name="attenddate" v-model="holiday" />
                  <input type="hidden" name="classid" v-model="form.classid" />
                  <input type="hidden" name="groupid" v-model="form.groupid" />
                  <input type="hidden" name="grade" v-model="form.grade" />
                </div>
                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary" v-if="isNew">
                    등록
                  </button>
                  <button type="submit" class="btn btn-primary" v-else>
                    수정
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <!-- <span>※.</span> -->
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="talentModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="talentModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="talentModalLabel" style="color: blue">
              <div>달란트</div>
            </h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label style="font-weight: bold;">{{ talentForm.name }}</label> 학생의 달란트 점수
              <input
                type="number"
                class="form-control"
                v-model="talentForm.points"
                placeholder="점수를 입력하세요"
                style="margin-top: 10px;"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="saveTalent">
              저장
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import manageService from "../services/manageService";

  import $ from "jquery";

  export default {
    name: "list",
    component: {},
    data() {
      return {
        dayLists: {},
        pageTotalCount: 0,
        page: 15,
        holiday: "00",
        currentDept: "",
        memberLists: {},
        id: this.$store.state.id,
        grade: this.$store.state.grade,
        phone: this.$store.state.phone,
        name: this.$store.state.name,
        teacherid: this.$store.state.teacherid,
        role: this.$store.state.role,
        token: this.$store.state.token,
        classid: this.$store.state.classid,
        form: {
          studentid: "",
          teacherid: "",
          no: "",
          attenddate: "",
          pray: "",
          name: "",
          sex: "",
          classid: "",
          groupid: "",
          grade: "",
        },
        isNew: false,
        firstselect: "selected",
        gradegrouplist: {},
        gradegroup: "00",
        talentForm: {
          no: "",
          studentid: "",
          teacherid: "",
          classid: "",
          groupid: "",
          grade: "",
          name: "",
          points: 0,
        },
      };
    },
    created() {
      //this.initGetMemberList(this.currentDept);
    },
    computed: {
      photourl() {
        return (url) => {
          return "./upload/photo/" + url;
        };
      },
    },
    methods: {
      gradeListLabel(g) {
        if (!g) return "";
        if (g.listlabel != null && g.listlabel !== "") return g.listlabel;
        const a = (g.gradename != null ? String(g.gradename) : "").trim();
        const b = (g.teachername != null ? String(g.teachername) : "").trim();
        const hideNames = ["선생님", "새가족", "새친구", "새얼굴"];
        if (hideNames.includes(a)) return a;
        if (a && b) return `${a} ${b}`;
        return a || b;
      },
      getGradeGroup() {
        if (this.holiday === "00") {
          this.$toast.show("날짜를 먼저 선택해주세요.", {
            type: "warning",
            position: "top-right",
          });
          //this.gradegroup = "00";
          //return;
        }

        const data = {
          attenddate: this.holiday,
          grade: this.gradegroup,
          teacherid: this.form.teacherid,
          role: this.role,
          classid: this.classid,
        };

        manageService
          .getAttendanceList(data)
          .then((response) => {
            this.memberLists = response.data;
          })
          .catch((e) => {
            console.log(e);
          });
      },
      getGradeGroupList() {
        const ndata = {
          classid: this.classid,
          grade: this.gradegroup,
          role: this.role,
        };
console.log("ndata ==  ", ndata );
        // 학년 반을 선택하세요.
        manageService
          .getGradeListAll(ndata)
          .then((response) => {
            //this.manageLists = response.data;
            this.gradegrouplist = response.data;
          })
          .catch((e) => {
            console.log(e);
          });
      },
      //개행문자 인식
      getHtmlConvert(str) {
        const replacer = new RegExp("\\n", "g");
        return str.replace(replacer, "<br />");
      },
      getDayList() {
        manageService
          .getDaysList()
          .then((response) => {
            this.dayLists = response.data.slice(0, this.page);
          })
          .catch((e) => {
            console.log(e);
          });
      },
      //전체 리스트 가져오기
      getStudentList(item) {

        console.log("item == ", this.gradegroup);

        //if( this.gradegroup === "00") return;

        // 관리자(Role 1 or 4)의 경우, 반 선택(gradegroup)이 되어있지 않으면 조회하지 않음
        if (this.role == 1 || this.role == 4) {
          if (this.gradegroup == "00") {
            this.memberLists = [];
            return;
          } else {
            // 반이 선택되어 있다면 해당 반 기준으로 조회 (날짜 변경 시)
            this.getGradeGroup();
            return;
          }
        }

        const data = {
          attenddate: item.holiday,
          grade: item.grade,
          teacherid: item.teacherid,
          role: this.role,
          classid: this.classid,
        };
       
        manageService
          .getAttendanceList(data)
          .then((response) => {
            this.memberLists = response.data;           
          })
          .catch((e) => {
            console.log(e);
          });

      },

      //잘못된 사진 리셋하기
      photoreset(item,sector){
        const data = {
          classid: item.classid,
          studentid: item.studentid,
          grade: item.grade,
          sector: sector,      
          groupid: item.groupid,          
        };

        manageService
          .setphotoreset(data)
          .then(() => {
            this.$toast.show("사진이 리셋되었습니다.", {
              type: "success",
              position: "top-right",
            });
            //this.getStudentList(data);
          })
          .catch((e) => {
            console.log(e);
          });

      },
      attendcheck(item, sector) {
        //출석체크
        var checkyn = "";
        if(sector == "1"){  // 부서
          if (item.attendyn == "Y") {
            checkyn = "N";
          } else {
            checkyn = "Y";
          }
        } else {           //반출석
          if (item.cellattendyn == "Y") {
            checkyn = "N";
          } else {
            checkyn = "Y";
          }          
        }


        const data = {
          classid: item.classid,
          studentid: item.studentid,
          grade: item.grade,
          sector: sector,
          holiday: this.holiday,
          teacherid: item.teacherid,
          groupid: item.groupid,
          checkyn: checkyn,          
        };

        manageService
          .setAttendChech(data)
          .then(() => {
            this.$toast.show("출결이 처리되었습니다.", {
              type: "success",
              position: "top-right",
            });
            this.getStudentList(data);
          })
          .catch((e) => {
            console.log(e);
          });
      },

      reporting(item) {
        //리포트 보고서

        this.isNew = true;
        this.form.studentid = item.studentid;
        this.form.teacherid = item.teacherid;
        this.form.no = item.no;
        this.form.attenddate = item.attenddate;
        this.form.pray = item.pray;
        this.form.name = item.name;
        this.form.sex = item.sex;
        this.form.classid = item.classid;
        this.form.groupid = item.groupid;
        this.form.grade = item.grade;

        $("#reportModal").modal("show");
      },

      addReportForm(e) {
        e.preventDefault();
        var object = {};
        var fform = document.getElementById("addReportForm");
        var form = new FormData(fform);
        form.forEach(function (value, key) {
          object[key] = value;
        });

        var jsondata = JSON.stringify(object);

        const data = {
          classid: JSON.parse(jsondata).classid,
          studentid: JSON.parse(jsondata).studentid,
          grade: JSON.parse(jsondata).grade,
          sector: "1",
          holiday: this.holiday,
          teacherid: JSON.parse(jsondata).teacherid,
          groupid: JSON.parse(jsondata).groupid,
          checkyn: "",
        };

        if (JSON.parse(jsondata).pray.length < 2) {
          this.$toast.show("내용을 입력해주세요.", {
            type: "warning",
            position: "top-right",
          });
          return;
        }
        //신규 모드
        manageService
          .reportWrite(jsondata)
          .then(() => {
            this.$toast.show("보고서가 등록되었습니다.", {
              type: "success",
              position: "top-right",
            });
            this.getStudentList(data);
            $("#reportModal").modal("hide");
          })
          .catch((e) => {
            console.log(e);
            this.$toast.show("보고서가 등록되지 않았습니다.", {
              type: "warning",
              position: "top-right",
            });
          });
      },

      openTalentModal(item) {
        this.talentForm.studentid = item.studentid;
        this.talentForm.teacherid = item.teacherid;
        this.talentForm.no = item.no;
        this.talentForm.classid = item.classid;
        this.talentForm.groupid = item.groupid;
        this.talentForm.grade = item.grade;
        this.talentForm.name = item.name;
        this.talentForm.points = item.points || 0; // 기존 점수가 없으면 0

        $("#talentModal").modal("show");
      },

      saveTalent() {
        const data = {
          classid: this.talentForm.classid,
          studentid: this.talentForm.studentid,
          grade: this.talentForm.grade,
          attenddate: this.holiday,
          teacherid: this.talentForm.teacherid,
          groupid: this.talentForm.groupid,
          points: this.talentForm.points,
        };

        manageService
          .savePoints(data)
          .then(() => {
            this.$toast.show("달란트 점수가 저장되었습니다.", {
              type: "success",
              position: "top-right",
            });
            
            // 리스트 전체를 새로 불러오지 않고, 해당 학생의 points만 업데이트
            const targetStudent = this.memberLists.find(
              (m) => m.studentid === this.talentForm.studentid
            );
            if (targetStudent) {
              targetStudent.points = this.talentForm.points;
            }
            
            $("#talentModal").modal("hide");
          })
          .catch((e) => {
            console.log(e);
            this.$toast.show("저장에 실패했습니다.", {
              type: "warning",
              position: "top-right",
            });
          });
      },
    },
    mounted() {
      this.getDayList();
      this.getGradeGroupList();
    },
  };
</script>

<style>
  .list {
    text-align: left;
    max-width: 750px;
    margin: auto;
  }
  .done {
    background: oldlace;
  }
</style>
